import.meta.globEager('@assets/images/**/*.{jpg,jpeg,png}', {
	query: { format: 'webp', quality: 80 },
});

import { vars } from '@config/variables';
import { disableScroll, enableScroll, getDeviceType, classInstance } from '@config/helpers';

import { PictureLazy } from '@ui/common/picture/picture';
import { ScrollTo } from '@ui/common/scrollto/scrollto';
import { Video } from '@ui/common/video/video';

window.app = {};
window.vars = vars;

window.app.classInstance = classInstance;
window.app.disableScroll = disableScroll;
window.app.enableScroll = enableScroll;
window.app.getDeviceType = getDeviceType;

window.app.PictureLazy = PictureLazy;
window.app.ScrollTo = ScrollTo;
window.app.Video = Video;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('picture.js-lazy').forEach((element) => new app.PictureLazy(element));
	document.querySelectorAll('.js-scrollto').forEach((element) => {
		new app.ScrollTo(element, { offset: 40 });
	});
	document.querySelectorAll('.js-video').forEach((element) => new app.Video(element));
});
